import styles from './Loading.module.css';

export function Loading() {
	return (
		<div className={styles['loading']}>
			<Topbar />
			<Content />
		</div>
	);
}

function Topbar() {
	return (
		<nav>
			<div>
				<div className={styles['shine']} />
				<div className={styles['shine']} />
			</div>
			<div>
				<div className={styles['shine']} />
			</div>
			<div>
				<div className={styles['shine']} />
				<div className={styles['shine']} />
				<div className={styles['shine']} />
			</div>
		</nav>
	);
}

function Content() {
	return (
		<section>
			<div className={styles['content']}>
				<div className={styles['shine']} />
				<div className={styles['shine']} />
				<div className={styles['shine']} />
				<div className={styles['shine']} />
				<div className={styles['shine']} />
				<div className={styles['shine']} />
				<div className={styles['shine']} />
				<div className={styles['shine']} />
			</div>
		</section>
	);
}
